<template>
  <div class="Administrativ">

<b-form @submit="onSubmit" @reset="onReset">

    <h3 class="underline clearfix pt-3">Administrativ
       <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
        abbrechen
        </b-button>
        <b-button v-if="!editMode" :pressed.sync="editMode" variant="default" class="profile_button float-right">
          <span class="bi-pencil" aria-hidden="true"></span>
        </b-button>
        <b-button v-if="editMode" type="submit" size="sm" variant="primary" class="float-right">
        speichern
        </b-button>
    </h3>
    <div class="row">

   <div class="col-sm-12 col-md-6">

      <b-form-group
      label="Name"
      label-for="input-name"
      class="mb-0"  >
      <b-form-input id="input-name" v-model="user.name" placeholder="nicht vorhanden" :readonly="!editMode"></b-form-input>
      </b-form-group>
      <b-form-group
      label="E-Mail Intern / Login"
      label-for="input-email"
      :invalid-feedback="errors.username"
      :state="!errors.username"
      class="mb-0"  >
      <b-form-input id="input-email" v-model="user.username"  placeholder="nicht vorhanden" :readonly="!editMode || profil" type="email"></b-form-input>
      </b-form-group>

<div v-if="hasRole('Admin')">
       <b-form-group
      label="Rollen"
      v-slot="{ ariaDescribedby }"
      class="mb-0">
      <b-form-checkbox-group
        v-model="rolesSelected"
        :options="roleOptions"
        :aria-describedby="ariaDescribedby"
        name="flavour-1a" :disabled="!editMode"
      ></b-form-checkbox-group>
    </b-form-group>
       <b-form-group label="Attribute"
             class="mb-0"  >
         <b-form-checkbox v-model="user.active" :disabled="!editMode"  switch inline>Profil aktiv</b-form-checkbox>
         <b-form-checkbox v-model="user.enabled" :disabled="!editMode"  switch inline>Kann Jobanfragen erhalten</b-form-checkbox>
      </b-form-group>
</div>
      <b-form-group
      label="KundenNr"
      label-for="input-kdnr"
      class="mb-0"  >
      <b-form-input id="input-kdnr" v-model="user.kundennr" placeholder="nicht vorhanden" :readonly="!editMode"></b-form-input>
      </b-form-group>
      <b-form-group
      label="Sevdesk ID"
      label-for="input-sevdeskid"
      class="mb-0"  >
      <b-form-input id="input-sevdeskid" v-model="user.sevdeskId" placeholder="nicht vorhanden" :readonly="!editMode"></b-form-input>
      </b-form-group>
      <b-form-group
      label="Mitglied seit"
      label-for="input-mgseitr"
      class="mb-0"  >
      <b-form-input id="input-mgseit" v-model="user.mitgliedSeit" placeholder="nicht verfügbar" :readonly="!editMode"></b-form-input>
      </b-form-group>

      <b-form-group
      label="Profil URL"
      label-for="input-pageurl"
      class="mb-0">
      <b-input-group>
      <b-form-input id="input-pageurl" v-model="user.pageUrl" placeholder="nicht verfügbar" :readonly="!editMode"></b-form-input>
      <b-input-group-append is-text>
      <b-form-checkbox
      id="page-ative"
      v-model="user.profilLinkActive"
      value="true"
      :disabled="!editMode"
      unchecked-value="false">
    </b-form-checkbox>
    </b-input-group-append>
    </b-input-group>
      </b-form-group>

      <b-form-group
      label="Standort"
      label-for="input-standort"
      class="mb-0"  >
      <b-form-select
          id="input-1"
          v-model="user.standortId"
          :disabled="!editMode" >
          <option v-for="(sp, idx) in standorte" v-bind:key="idx" :value="sp.id">{{sp.name}}</option>
      </b-form-select>
      </b-form-group>

<div class="mt-3">
       <b-form-checkbox v-model="user.rechnungadresse" :disabled="!editMode"  inline>Abweichende Rechnungsadresse</b-form-checkbox>
</div>
    <div v-if="user.rechnungadresse">
    <h5 class="mt-3">Rechnungsdaten</h5>
       <b-form-group
      label="Name"
      label-for="input-rgstrasse"
      class="mb-0"  >
          <b-form-input id="input-rgname" :readonly="!editMode" v-model="user.rgName" placeholder="nicht vorhanden" ></b-form-input>
       </b-form-group>
       <b-form-group
      label="Strasse"
      label-for="input-rgstrasse"
      class="mb-0"  >
          <b-form-input id="input-rgstrasse" :readonly="!editMode" v-model="user.rgStrasse" placeholder="nicht vorhanden" ></b-form-input>
       </b-form-group>
  <div class="row">
    <div class="col-xs-12 col-md-2">
          <b-form-group
          label="PLZ"
          label-for="input-rgplz"
          class="mb-0"  >
              <b-form-input id="input-rgplz" :readonly="!editMode" v-model="user.rgPlz" placeholder="nicht vorhanden" ></b-form-input>
           </b-form-group>
    </div>
    <div class="col-xs-12 col-md-10">
          <b-form-group
          label="Ort"
          label-for="input-rgort"
          class="mb-0"  >
              <b-form-input id="input-rgort" :readonly="!editMode" v-model="user.rgOrt" placeholder="nicht vorhanden" ></b-form-input>
           </b-form-group>
    </div>
  </div>

         <b-form-group
      label="E-Mail für Rechnungen"
      label-for="input-email"
      class="mb-0" >
      <b-form-input id="input-email" v-model="user.rgEmail"  placeholder="nicht vorhanden" :readonly="!editMode" type="email"></b-form-input>
      </b-form-group>
      </div>
   </div>
   <div class="col-sm-12 col-md-6">
   <b-form-group
      label="Zuletzt vermittelt Preset"
      label-for="input-zuletzt-vermittelt-presetl"
      class="mb-0"  >
    <b-form-datepicker id="input-zuletzt-vermittelt-presetl" v-model="user.zuletztVermitteltPreset" :readonly="!editMode"></b-form-datepicker>
    </b-form-group>

      <b-form-group
      label="Gage zu Beginn"
      label-for="input-name"
      class="mb-0" >
        <b-input-group append="EUR">
      <b-form-input id="input-name" v-model="user.gageOffset" placeholder="nicht vorhanden" :readonly="!editMode"></b-form-input>
      </b-input-group>
      </b-form-group>

      <b-form-group
      label="Provisionen und Jahresbeiträge"
      label-for="input-provisionen"
      class="mb-0" >
      <div class="pb-3">
      <EditableTable ref="EditableTable" :items="user.provisionen" :editMode="editMode" />
      </div>
      </b-form-group>
      <b-form-group
      label="Folgetage"
      label-for="input-folgetage"
      class="mb-0" >

      <div class="pb-3">
      <EditableTable ref="EditableTable" :items="user.folgetage" :editMode="editMode" />
      </div>
      </b-form-group>
      <b-form-group
      label="Umsätze"
      label-for="input-folgetage"
      class="mb-0" >

      <div class="pb-3">
      <CutterAuftragTable ref="auftragTable" :user="user" :editMode="editMode" />
      </div>
      </b-form-group>

      <b-form-group
      label="Bewertungen"
      label-for="input-provisionen"
      class="mb-0"  >
      <b-form-textarea id="textarea-bewertung" :plaintext="!editMode" :readonly="!editMode" v-model="user.bewertung" placeholder="nicht vorhanden"></b-form-textarea>
      <div class="pb-3">
       <div v-for="(bewertung, id) in user.bewertungen" :key="id"><b-link :to="auftragLink(id)">Auftrag #{{id}}</b-link><div v-html="nl2br(bewertung)"></div></div>
      </div>
      </b-form-group>
   </div>
   </div>
   <div class="row">
   <div class="col mt-3">
        <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
        abbrechen
        </b-button>
        <b-button v-if="editMode" type="submit" size="sm" variant="primary" class="float-right">
        speichern
        </b-button>
   </div>
   </div>

 </b-form>

  </div>
</template>

<script>
import api from '@/api/benutzer'
import Role from '@/models/Role'
import EditableTable from '@/components/partials/EditableTable'
import CutterAuftragTable from '@/components/partials/CutterAuftragTable'

import utils from '@/utilities'

export default {
  name: 'Adminatrativ',
  props: ['user', 'profil'],
  components: {
    EditableTable, CutterAuftragTable
  },
  watch: {
    async editMode (val) {
      if (!val) {
        this.errors = {}
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
      }
    }
  },
  computed: {
    rolesSelected: {
      get () {
        return utils.userRoles(this.user)
      },
      set (roles) {
        this.roles = roles
        return roles
      }
    }
  },
  methods: {
    nl2br (value) {
      return value.replace(/(?:\r\n|\r|\n)/g, '<br>')
    },
    auftragLink (id) {
      return '/auftrag/' + id
    },
    async onSubmit (event) {
      event.preventDefault()
      event.stopPropagation()
      if (!this.editMode) {
        this.editMode = !this.editMode
        return
      }
      let httpForm = new FormData()

      const items = ['name', 'kundennr', 'sevdeskId', 'mitgliedSeit', 'standortId', 'telefon', 'email', 'rgName', 'rgPlz', 'rgOrt', 'rgStrasse', 'rgEmail', 'pageUrl', 'username', 'since', 'zuletztVermitteltPreset', 'profilLinkActive', 'bewertung', 'gageOffset']
      items.forEach(key => {
        httpForm.append(key, this.user[key])
      })
      httpForm.append('rechnungadresse', this.user.rechnungadresse)
      httpForm.append('active', this.user.active)
      httpForm.append('enabled', this.user.enabled)
      httpForm.append('roles', this.roles)
      httpForm.append('folgetage', JSON.stringify(this.user.folgetage))
      httpForm.append('provisionen', JSON.stringify(this.user.provisionen))

      let result = await api.update(this.user.id, httpForm)
      if (result && !result.username) {
        this.editMode = false
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
        this.errors = {}
      } else {
        this.errors = result
      }
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.form = []
      this.errors = {}
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    hasRole (role) {
      return this.hasRoles([role])
    },
    hasRoles (role) {
      return utils.hasAnyRole(utils.tokenRoles(this.$store.state.auth.token), role)
    }
  },
  data () {
    return {
      roles: [],
      roleOptions: Role.asOptions(this.$store.state.auth.baseData.roles),
      errors: {},
      standorte: this.$store.state.auth.baseData.standorte,
      editMode: false,
      loading: false
    }
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/profil/Administrativ.vue